import AttendanceAdapter from './base';

export default class NzMoeDay extends AttendanceAdapter {
  modelNamePlural = 'nzMoeDays';
}
